export { LoyaltyIcon } from './LoyaltyIcon';
